import api from "./api";

export interface WalletData {
  wallet: {
    id: string;
    balance: string;
    locked_balance: string;
    available_balance: string;
    external_address: string | null;
  };
}

export interface Transaction {
  id: string;
  wallet_id: string;
  type: string;
  amount: string;
  balance_after: string;
  description: string | null;
  reference_id: string | null;
  created_at: string;
}

export const walletService = {
  async get() {
    const response = await api.get<{ success: boolean; data: WalletData }>("/wallet");
    return response.data.data;
  },

  async getTransactions(params?: { limit?: number; offset?: number; type?: string }) {
    const response = await api.get<{ success: boolean; data: { transactions: Transaction[] } }>("/wallet/transactions", {
      params,
    });
    return response.data.data;
  },

  async deposit(amount: string) {
    const response = await api.post<{ success: boolean; data: WalletData }>("/wallet/deposit", { amount });
    return response.data.data;
  },

  async withdraw(amount: string, address: string) {
    const response = await api.post<{ success: boolean; data: WalletData }>("/wallet/withdraw", { amount, address });
    return response.data.data;
  },

  async updateAddress(external_address: string) {
    const response = await api.patch<{ success: boolean; data: WalletData }>("/wallet", { external_address });
    return response.data.data;
  },
};
